import { Component, OnInit } from '@angular/core';

@Component({
  // tslint:disable-next-line: component-selector
  selector: 'activity-get',
  templateUrl: './get.component.html',
  styleUrls: ['./get.component.scss'],
})
export class GetActivityComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
